import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: { categories: [], siteConfig: {} },
  mutations: {
    SET_CATEGORIES(state, data) { state.categories = data },
    SET_CONFIG(state, data) { state.siteConfig = data }
  }
})
